import { defineComponent as N, useSlots as V, computed as s, useAttrs as w, createElementBlock as y, openBlock as B, normalizeClass as r, createElementVNode as n, renderSlot as z, mergeProps as E } from "vue";
import { usePropsValidation as S } from "../../composables/usePropsValidation.js";
import { omit as A } from "../../utils/omit.js";
import { tw as e } from "../../utils/tailwind.js";
import { CHANGE_EVENT as T } from "./RadioBase.constant.js";
const _ = ["id", "checked", "disabled", "value"], G = /* @__PURE__ */ N({
  name: "RevRadioBase",
  inheritAttrs: !1,
  __name: "RadioBase",
  props: {
    modelValue: { type: [Boolean, String] },
    disabled: { type: Boolean, default: !1 },
    id: {},
    label: {},
    value: {},
    checkmarkClassNames: { default: "" },
    checkmarkTickClassNames: { default: e`left-6 top-8` }
  },
  emits: ["change", "update:modelValue"],
  setup(c, { emit: m }) {
    const a = c, p = V(), d = m, u = s(() => !!p.default), t = s(() => !u.value), o = s(() => typeof a.modelValue == "string" ? a.modelValue === a.value : a.modelValue);
    function b(l) {
      l.target.value !== a.modelValue && (d(T, l), d("update:modelValue", l.target.value));
    }
    S({
      "If no slot is passed, `props.label` is mandatory": () => t.value && !a.label
    });
    const f = s(() => {
      const l = w();
      return {
        ...A(l, ["class"]),
        ...t.value && a.label && {
          "aria-label": a.label
        }
      };
    }), v = s(() => [
      e`relative`,
      t.value && e`size-20`
    ]), h = s(() => [
      e`peer appearance-none outline-none`,
      u.value && e`sr-only`,
      t.value && e`rounded-full absolute inset-x-0 bottom-0 top-2 size-20`,
      t.value && !a.disabled && e`cursor-pointer`,
      t.value && a.disabled && e`cursor-not-allowed`
    ]), i = e`rounded-full pointer-events-none absolute`, k = s(() => [
      i,
      a.checkmarkClassNames,
      e`box-border size-20 border`,
      t.value && "left-0 top-2 peer-focus-visible:outline-default-hi",
      o.value ? e`bg-action-default-low-pressed` : e`bg-action-default-low`,
      a.disabled && e`bg-action-default-low-disabled border-action-default-hi-disabled`,
      a.disabled && o.value && e`border-transparent`
    ]), C = s(() => [
      i,
      a.checkmarkTickClassNames,
      e`bg-action-default-low size-8 shrink-0`,
      a.disabled && e`bg-action-default-low-pressed opacity-50`,
      o.value ? e`block` : e`hidden`
    ]);
    return (l, g) => (B(), y("div", {
      class: r([l.$attrs.class, v.value])
    }, [
      n("input", E({ id: l.id }, f.value, {
        checked: o.value,
        class: h.value,
        disabled: l.disabled,
        type: "radio",
        value: l.value,
        onChange: b
      }), null, 16, _),
      z(l.$slots, "default"),
      n("div", {
        class: r(k.value)
      }, null, 2),
      n("div", {
        class: r(C.value)
      }, null, 2)
    ], 2));
  }
});
export {
  G as default
};
